import React from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    variant: '900' | '800' | '700' | '600' | '500';
    size?: 'sm' | 'md' | 'lg' | 'xl';
    type?: 'default' | 'success' | 'danger' | 'warning';
}

export default function Surface({ variant, size = 'md', type = 'default', className, ...props }: Props) {
    let classNames = 'text-theme-text ';
    if (type === 'default') {
        classNames += {
            '900': 'bg-theme-900',
            '800': 'bg-theme-800',
            '700': 'bg-theme-700',
            '600': 'bg-theme-600',
            '500': 'bg-theme-500',
        }[variant];
        classNames += ' border-theme-outline';
    } else if (type === 'danger') {
        classNames += 'bg-red-500/10 border-red-500/30';
    } else if (type === 'warning') {
        classNames += 'bg-yellow-500/10 border-yellow-500/30';
    } else if (type === 'success') {
        classNames += 'bg-green-400/10 border-green-400/30';
    }

    classNames +=
        ' ' +
        {
            sm: 'shadow-sm p-2 round:rounded-lg',
            md: 'shadow p-4 round:rounded-xl',
            lg: 'shadow-lg px-6 py-4 round:rounded-2xl',
            xl: 'shadow-xl px-8 py-6 round:rounded-3xl',
        }[size];

    classNames += ' border border-theme-outline';

    if (className) classNames += ' ' + className;

    return <div {...props} className={classNames} />;
}
